import { AssetTypes } from 'components/common/types/AssetList.types';
import { Environment } from 'components/common/types/Deal.types';
import { DirectSalesMediaType } from 'components/common/types/DirectSalesCampaign.types';
import { ReferenceLocation } from 'store/userOptions/reducer.types';

export type LoadReferenceDataOptions = {
  environments?: Environment[];
  mediaType?: DirectSalesMediaType | AssetTypes;
  startDate?: Date | string | null;
  endDate?: Date | string | null;
  isProductTemplate?: boolean;
};

export type UseReferenceDataProps = {
  isDirectSales?: boolean;
};

type UseReferenceDataResult = {
  loadReferenceData: (options: LoadReferenceDataOptions) => Promise<boolean>;
};

export type UseReferenceData = (props?: UseReferenceDataProps) => UseReferenceDataResult;

type LocationCategory = keyof ReferenceLocation;

export const programmaticLocationCategories: LocationCategory[] = ['country', 'town', 'postcode', 'address', 'county'];

export const directSalesLocationCategories: LocationCategory[] = [
  'routeTown',
  'postcode',
  'conurbation',
  'tvArea',
  'country',
  'county',
  'town',
  'district',
];
